import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, type LucideProps } from 'lucide-react';
import { cn } from '@/lib/cn';

// Direction-aware icons: drawn for LTR and mirrored in RTL, so "forward"
// always points the way the reader moves.
export const ForwardArrow = ({ className, ...p }: LucideProps) => <ArrowRight {...p} className={cn('rtl:-scale-x-100', className)} />;
export const BackArrow = ({ className, ...p }: LucideProps) => <ArrowLeft {...p} className={cn('rtl:-scale-x-100', className)} />;
export const ForwardChevron = ({ className, ...p }: LucideProps) => <ChevronRight {...p} className={cn('rtl:-scale-x-100', className)} />;
export const BackChevron = ({ className, ...p }: LucideProps) => <ChevronLeft {...p} className={cn('rtl:-scale-x-100', className)} />;
